
addEventListener("DOMContentLoaded", (event) => {
  
  // check product page
  if (document.querySelector("body.product")) {

    // const showPre = document.querySelectorAll(".Pre_orderrr");

    // product size input
    prdSize = document.querySelectorAll(".swatch_options input");
    // const preOrderBtn = "PRE ORDER NOW";
    const preOrderBtn = "PRE ORDER";
    const addToCartBtn = "ADD TO CART";
    const soldOutBtn = "SOLD OUT";

    // const commingBtn = "COMMING SOON";
    const cartBtn = document.querySelector("form .ajax-submit span");

    if (prdSize[0]) {
      for (let i = 0; i < prdSize.length; i++) {
        prdSize[i].addEventListener("change",function(){
          
          setTimeout(() => {
             // check pre order products


            // if (showPre.length > 0){
            //   if (cartBtn.parentElement.getAttribute("disabled")) {
            //     cartBtn.parentElement.removeAttribute("disabled");
            //     cartBtn.parentElement.parentElement.classList.remove("product-is-unavailable");
            //   }
            //   if (document.querySelector(".prdofs")) {
            //     document.querySelector(".price-ui-badges").classList.remove("prdofs");
            //   }

            //   cartBtn.innerHTML = preOrderBtn;
              // document.querySelector(".inventory_msg").innerHTML = "PRE ORDER" 
            //   console.log("Pre Order Console Log");

            // }
            // else


            // if (this.getAttribute("cuspreorder") === "true") {
              // console.log(this.dataset.preorderAvailable);
            if (this.dataset.preorderAvailable == "true") {
                // console.log("available true");
              if (cartBtn.parentElement.getAttribute("disabled")) {
                cartBtn.parentElement.removeAttribute("disabled");
                cartBtn.parentElement.parentElement.classList.remove("product-is-unavailable");
              }
              if (document.querySelector(".prdofs")) {
                document.querySelector(".price-ui-badges").classList.remove("prdofs");
              }
              
              cartBtn.innerHTML = preOrderBtn;
              // console.log("preOrder");

              document.querySelector(".inventory_msg").innerHTML = "PRE ORDER" // update inventory msg 
              
            }

            // check comming soon order products
            // else if (this.getAttribute("cuspreorder") === "comming") {
            //   if (!cartBtn.parentElement.getAttribute("disabled")) {
            //     cartBtn.parentElement.setAttribute("disabled", "disabled");
            //   }
            //   cartBtn.innerHTML = soldOutBtn;
            //   console.log("soldOutBtn");
            // }
  
            // check in stock products
            else{
              if (this.getAttribute("varinstock") === "in") {
                if (cartBtn.parentElement.getAttribute("disabled")) {
                  cartBtn.parentElement.removeAttribute("disabled");
                  cartBtn.parentElement.parentElement.classList.remove("product-is-unavailable");
                }
                if (document.querySelector(".prdofs")) {
                  document.querySelector(".price-ui-badges").classList.remove("prdofs");
                }
                cartBtn.innerHTML = addToCartBtn;
                // console.log("addToCart");

                document.querySelector(".inventory_msg").innerHTML = "IN STOCK" // update inventory msg 
              }
  
              // check out of stock products
              else{
                if (!cartBtn.parentElement.getAttribute("disabled")) {
                  cartBtn.parentElement.setAttribute("disabled", "disabled");
                  cartBtn.parentElement.parentElement.classList.add("product-is-unavailable");
                }
               if (!document.querySelector(".prdofs")) {
                  document.querySelector(".price-ui-badges").classList.add("prdofs");
                }
                cartBtn.innerHTML = soldOutBtn;
                // console.log("soldOut");

                document.querySelector(".inventory_msg").innerHTML = "OUT OF STOCK" // update inventory msg 
              }
            }
          }, 0);
         
        });

      }



      // click trigger on current selected variant
      setTimeout(() => {
        prdSize.forEach(element => {
          if (element.checked) {
            element.dispatchEvent(new Event('change'))
          }
        });
      }, 0);

    }
    else{
      // update add to cart text  
      setTimeout(() => {
      const inventoryElement = document.querySelector(".inventory_msg");
      if (inventoryElement && inventoryElement.innerHTML.indexOf("PRE ORDER") != -1) {
          cartBtn.innerHTML = preOrderBtn;
        }
      }, 100);
    }

    
    // window.onload = function() {
    setTimeout(() => {
      prdSize.forEach((elemEach)=>{
        if (elemEach.checked) {
          // console.log("elemChecked");
          // if (this.getAttribute("cuspreorder") === "true") {
          if (elemEach.dataset.preorderAvailable == "true") {
              // console.log("available true");
              let cartBtn = document.querySelector('.purchase-details__buttons .ajax-submit span');
            if (cartBtn.parentElement.getAttribute("disabled")) {
              cartBtn.parentElement.removeAttribute("disabled");
              cartBtn.parentElement.parentElement.classList.remove("product-is-unavailable");
            }
            if (document.querySelector(".prdofs")) {
              document.querySelector(".price-ui-badges").classList.remove("prdofs");
            }
            const preOrderBtn = "PRE ORDER";
            cartBtn.innerHTML = preOrderBtn;
            // console.log("preOrder");
  
            // document.querySelector(".inventory_msg").innerHTML = "PRE ORDER" // update inventory msg 
            
          }
        }
      });
    }, 200);
    
    
      prdSize.forEach((defaultVar)=>{
        setTimeout(() => {
          if (defaultVar.getAttribute("varinstock") === "in") {
            if (cartBtn.parentElement.getAttribute("disabled")) {
              cartBtn.parentElement.removeAttribute("disabled");
              cartBtn.parentElement.parentElement.classList.remove("product-is-unavailable");
            }
            if (document.querySelector(".prdofs")) {
              document.querySelector(".price-ui-badges").classList.remove("prdofs");
            }
            cartBtn.innerHTML = addToCartBtn;
            // console.log("addToCart");
  
            // document.querySelector(".inventory_msg").innerHTML = "IN STOCK" // update inventory msg 
          }
  
          // check out of stock products
          // else{
          //   if (!cartBtn.parentElement.getAttribute("disabled")) {
          //     cartBtn.parentElement.setAttribute("disabled", "disabled");
          //     cartBtn.parentElement.parentElement.classList.add("product-is-unavailable");
          //   }
          //  if (!document.querySelector(".prdofs")) {
          //     document.querySelector(".price-ui-badges").classList.add("prdofs");
          //   }
          //   cartBtn.innerHTML = soldOutBtn;
          //   console.log("soldOut");
  
          //   // document.querySelector(".inventory_msg").innerHTML = "OUT OF STOCK" // update inventory msg 
          // }
        }, 250);
      })
  };


  // Toggle Switch for website redirection
  // const toggleSwitch1 = document.querySelectorAll('.toggle-switch-1');
  // const toggleSwitch2 = document.querySelectorAll('.toggle-switch-2');
  
  // toggleSwitch1.forEach( e => e.addEventListener('click', () => window.location.href = 'https://eu.sparktrendz.com/' ));
  // toggleSwitch2.forEach( e => e.addEventListener('click', () => window.location.href = 'https://sparktrendz.com/' ));


  const toggleSwitch = document.querySelectorAll('.toggle-switch.toggle-switch-0');
  const popupModal = document.getElementById('popup-modal');
  const closeButton = document.querySelectorAll('.close-button');

  // console.log('toggleSwitch', toggleSwitch, popupModal, closeButton);
  

  // Show popup ONLY when user clicks the toggle switch
  if (toggleSwitch && popupModal && closeButton) {
    toggleSwitch?.forEach(elm => {
      elm.addEventListener('click', function () {
      popupModal.style.display = 'flex'; // Ensure modal uses flex for centering
    });
    })

    closeButton?.forEach(elm => {
      elm.addEventListener('click', function () {
      popupModal.style.display = 'none';
    });
    })

    // Clicking outside the modal content closes the popup
    window.addEventListener('click', function (event) {
      if (event.target === popupModal) {
        popupModal.style.display = 'none';
      }
    });
  }

});

document.addEventListener('DOMContentLoaded', function () {
  // console.log('[Shipping Bar] DOMContentLoaded');

  // Global function to update a single shipping bar
  window.updateShippingBar = function (wrapper, cartTotal) {
    const threshold = parseFloat(wrapper.dataset.threshold || '75');
    const currency = wrapper.dataset.currency || 'USD';
    const partialMessage = wrapper.dataset.partialmessage || 'You’re only [amount] from FREE shipping!';
    const freeMessage = wrapper.dataset.freemessage || '🎉 You got FREE shipping!';

    const messageEl = wrapper.querySelector('.cus-shipping-message');
    const progressEl = wrapper.querySelector('.cus-shipping-progress');

    const remaining = Math.max(threshold - cartTotal, 0);
    const percent = Math.min((cartTotal / threshold) * 100, 100).toFixed(2);

    if (cartTotal >= threshold) {
      messageEl.textContent = freeMessage;
      progressEl.style.setProperty('width', '100%');
      progressEl.classList.add('cus-shipping-progress--full');
    } else {
      const formatted = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(remaining);
      messageEl.textContent = partialMessage.replace('[amount]', formatted);
      progressEl.style.setProperty('width', percent + '%');
      progressEl.classList.remove('cus-shipping-progress--full');
    }

    // console.log('[Shipping Bar] Updated:', { threshold, cartTotal, remaining, percent });
  };

  // Global function to fetch cart and update all current shipping bars
  window.fetchCartAndUpdateAllBars = function () {
    // console.log('[Shipping Bar] Fetching cart...');

    const wrappers = document.querySelectorAll('.cus-shipping-bar-wrapper');
    if (!wrappers.length) {
      // console.warn('[Shipping Bar] No shipping bars found.');
      return;
    } else {
      // console.log('[Shipping Bar] Wrappers found:', wrappers.length);
    }

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartTotal = cart.total_price / 100;
        wrappers.forEach(wrapper => {
          window.updateShippingBar(wrapper, cartTotal);
        });
      })
      .catch(err => console.error('[Shipping Bar] Cart fetch error:', err));
  };

  // Initial run
  window.fetchCartAndUpdateAllBars();

  // Listen to known cart-related events
  ['cart:updated', 'quantity:updated', 'ajaxCart:done'].forEach(evt => {
    document.body.addEventListener(evt, () => {
      // console.log(`[Shipping Bar] Event triggered: ${evt}`);
      window.fetchCartAndUpdateAllBars();
    });
  });

  // Detect manual quantity updates
  document.addEventListener('click', e => {
    if (e.target.closest('.js-change-quantity') || e.target.closest('.product-quantity-box')) {
      // console.log('[Shipping Bar] Quantity change click');
      setTimeout(window.fetchCartAndUpdateAllBars, 1000);
    }
  });

  // Watch subtotal DOM changes
  const subtotalEl = document.querySelector('.cart_subtotal .money');
  if (subtotalEl) {
    new MutationObserver(() => {
      // console.log('[Shipping Bar] Subtotal mutation observed');
      window.fetchCartAndUpdateAllBars();
    }).observe(subtotalEl, {
      childList: true,
      subtree: true
    });
  }

  // Patch fetch to detect cart fetches
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    if (typeof args[0] === 'string' && args[0].includes('/cart.js')) {
      const clone = response.clone();
      clone.json().then(cart => {
        const cartTotal = cart.total_price / 100;
        document.querySelectorAll('.cus-shipping-bar-wrapper').forEach(wrapper => {
          window.updateShippingBar(wrapper, cartTotal);
        });
      });
    }
    return response;
  };
});

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".prd-hide_pre-order").forEach(function (productCard) {
//     // find the nearest product container
//     const productContainer = productCard.closest(".abcde13245"); // use your actual product wrapper class
//     const preOrderContainer = productContainer?.querySelector(".pre-order_prd-container._preOrder");

//     // hide if _preOrder is not found
//     if (!preOrderContainer) {
//       productCard.style.display = "none";
//     } else {
//       productCard.style.display = "";
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".pre-order_product-image").forEach(function (productImage) {
    // Check if the product image has the "true" class
    const hasTrueClass = productImage.classList.contains("true"); // replace "true" with your actual class name

    // Find the nearest .custom__product_card container
    const productCard = productImage.closest(".custom__product_card");

    // Hide the product card if the image does not have the true class
    if (!hasTrueClass) {
      productCard?.style.setProperty("display", "none", "important");
    }
  });
});